import React, { useContext, createContext, useState } from 'react';
import dayjs from 'dayjs';
import { useNotificationList } from 'hooks/useNotification';
import {
  NotificationMessage,
  NotificationMessageGroup,
} from 'model/notification';
import { useAuth } from './AuthProvider';
export const defaultPageSize = 1000;

const NotificationContext = createContext<{
  notificationGroupList: NotificationMessageGroup[];
  totalUnreadCount: number;
  loading: boolean;
  setLoading: (loading: boolean) => void;
  refetch: () => void;
}>({
  notificationGroupList: [],
  totalUnreadCount: 0,
  loading: false,
  setLoading: () => {},
  refetch: () => {},
});

const groupNotificationsByDate = (
  notifications?: NotificationMessage[],
): NotificationMessageGroup[] => {
  if (!notifications) {
    return [];
  }
  const result: NotificationMessageGroup[] = [];
  const map = new Map<string, NotificationMessage[]>();
  for (const notification of notifications) {
    const date = dayjs(notification.updatedAt).format('YYYY-MM-DD');
    if (map.has(date)) {
      map.get(date)?.push(notification);
    } else {
      map.set(date, [notification]);
    }
  }
  for (const [date, messages] of Array.from(map.entries())) {
    result.push({ date, messages });
  }
  return result;
};

const notifications: NotificationMessage[] = [
  {
    id: '1',
    userId: '1',
    familyId: '1',
    conditions: [],
    read: false,
    notificationText: 'First message',
    createdAt: '2024-03-20T10:00:00Z',
    updatedAt: '2024-03-20T10:00:00Z',
  },
  {
    id: '2',
    userId: '1',
    familyId: '1',
    conditions: [],
    read: false,
    notificationText: 'Second message',
    createdAt: '2024-03-20T15:00:00Z',
    updatedAt: '2024-03-20T15:00:00Z',
  },
  {
    id: '3',
    userId: '1',
    familyId: '1',
    conditions: [],
    read: false,
    notificationText: 'Third message',
    createdAt: '2024-03-19T10:00:00Z',
    updatedAt: '2024-03-19T10:00:00Z',
  },
];

const NotificationProvider = ({ children }: { children: React.ReactNode }) => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const { notificationList, refetch: refetchNotificationList } =
    useNotificationList({
      familyId: undefined,
      userId: user?.id,
      page: 0,
      pageSize: defaultPageSize,
    });

  return (
    <NotificationContext.Provider
      value={{
        notificationGroupList: groupNotificationsByDate(notificationList),
        totalUnreadCount:
          notificationList?.filter((item) => !item.read).length ?? 0,
        loading: loading,
        setLoading: setLoading,
        refetch: refetchNotificationList,
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};

export default NotificationProvider;

export const useNotification = () => {
  return useContext(NotificationContext);
};
